var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperclip({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5.65625px",
    height: "11.3125px",
    viewBox: "0 0 5.65625 11.3125",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6AED6201-9932-4930-9387-79B8B0543549") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prospecting",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Prospect-Details--Interaction-History--Documents",
    transform: "translate(-901.6853, -631.3031)",
    fill: "#207EC5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(887.6606, 614.66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(14.0247, 15.7993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Paperclip",
    transform: "translate(0, 0.8438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.82812641,10.5044643 C1.71249776,10.5044643 0.80803632,9.5998683 0.80803632,8.484375 L0.80803632,2.01928125 C0.80803632,1.69808705 0.935705963,1.38982143 1.162764,1.16276339 C1.38982203,0.935705357 1.69795312,0.808035714 2.01928226,0.808035714 C2.68995231,0.808035714 3.23214468,1.35022768 3.23214468,2.01928125 L3.23214468,7.67714732 C3.23214468,7.89976116 3.05168323,8.08035714 2.82893445,8.08035714 C2.60510856,8.08035714 2.42410815,7.89935714 2.42410815,7.67633929 L2.42410815,2.828125 C2.42410815,2.60510714 2.24310815,2.42410714 2.0200903,2.42410714 C1.79707244,2.42410714 1.61607244,2.60510714 1.61607244,2.828125 L1.61607244,7.67633929 C1.61607244,8.34579687 2.15880336,8.88839286 2.82812641,8.88839286 C3.49798843,8.88839286 4.04018039,8.34620089 4.04018039,7.67714732 L4.04018039,2.01928125 C4.04018039,0.904191964 3.13598802,0 2.02089833,0 C1.48382366,0 0.970182019,0.212917411 0.591482345,0.591482143 C0.212782832,0.970046875 0,1.48355357 0,2.01928125 L0,8.484375 C0,10.046308 1.26619257,11.3125 2.82812641,11.3125 C3.57825344,11.3125 4.29740523,11.0147388 4.82801561,10.4842634 C5.35835693,9.95378795 5.65625,9.23463616 5.65625,8.484375 C5.65625,6.1043058 5.65625,2.828125 5.65625,2.828125 C5.65625,2.60510714 5.47525263,2.42410714 5.25223477,2.42410714 C5.02921691,2.42410714 4.84821651,2.60510714 4.84821651,2.828125 L4.84821651,8.484375 C4.84821651,9.02010268 4.63543404,9.53401339 4.25646489,9.91298214 C3.87776521,10.2915469 3.3638545,10.5044643 2.82812641,10.5044643 Z",
    id: "path2"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/Paperclip.c62b21770f7e35b9a5b961747caa7c23.svg";
export { ForwardRef as ReactComponent };